export const theme = {
  // 主题色
  colorPrimary: '#c70019',
  // 边框颜色
  borderColor: '#cccccc',
  // 文字大小
  fontSizeBase: '13px',
  // 背景色
  colorBgBase: '#fff',
  // 操作失败的颜色
  colorError: '#ff4d4f',
  // 操作信息的颜色
  colorInfo: '#1677ff',
  // 操作成功的颜色
  colorSuccess: '#52c41a',
  // 文本颜色
  colorTextBase: '#000',
  // 操作警告的颜色
  colorWarning: '#faad14',
  // Ant Design 组件的圆角大小
  borderRadius: 0,
  // 按钮和输入框等基础控件的高度
  controlHeight: 32,
  // Ant Design 的字体家族
  fontFamily: 'Helvetica Neue, -apple-system, BlinkMacSystemFont, Segoe UI,\n' +
    '  PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,\n' +
    '  Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
  // 组件边框、分割线等的样式，默认是实线
  lineType: 'solid',
  // 组件边框、分割线等的宽度
  lineWidth: 1,
  // 动画时长的变化单位
  motionUnit: 0.1,
  // 组件尺寸的基础步长
  sizeStep: 4,
  // 组件尺寸的变化单位
  sizeUnit: 4,
  // 所有组件的基础 Z 轴值
  zIndexBase: 0,
  // 浮层类组件的基础 Z 轴值
  zIndexPopupBase: 1000,
  paddingLG: 12,
  fontSizeLG: 14,
  // 一些动画的缓动函数
  motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
  motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
  motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
  motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)'
}

export const components = {
  Table: {
    padding: 10,
    paddingContentVerticalLG: 10
  }
}
